import React from 'react';

import type { RootMenuItem } from '../../BettingMenu/types';

import { Item } from './components/Item';

import style from './RootMenu.module.scss';

type RootMenuItemsProps = {
  list: RootMenuItem[];
};

export const RootMenu: React.FC<RootMenuItemsProps> = ({
  list,
}) => {
  return (
    <ul className={style.list}>
      {list.map((entry) => (
        <Item key={entry.key}
              entry={entry} />
      ))}
    </ul>
  );
};
